'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/connettoricorrieri
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function ConnettoricorrieriRoutes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "connettoricorrieri",
        url: "/connettoricorrieri",
        //templateUrl: "ricambiweb/connettoricorrieri/scripts/templates/connettoricorrieri.html",
        template: require("../templates/connettoricorrieri.html"),
        controller: ["$http", "$q", "$timeout", "$state", "$stateParams", "DSFactory", "GridFactory", "GridCfgFactory", "ToolbarSrv", "identifica", "$scope", "$compile", "ActionFactory", "ErrorManager", "FormDaGridFactory", "Valida", "ConnettoricorrieriFunzioniAggiuntive", require("../ConnettoricorrieriCtrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = ConnettoricorrieriRoutes;
